module.exports = __webpack_public_path__ + "img/H1.71e42df8.png";